import {
	Directive,
	OnInit,
	TemplateRef,
	ViewContainerRef,
	Input,
} from '@angular/core';
import { RoleBasedParamModel } from '../../../app/core/models/role-based-param.model';
import { RoleGuard } from 'src/app/core/guards/role.guard';

@Directive({
	selector: '[appUserRole]',
	standalone: false
})
export class UserRoleDirective implements OnInit {
	constructor(
		private readonly templateRef: TemplateRef<any>,
		private readonly roleGuardService: RoleGuard,
		private readonly viewContainer: ViewContainerRef
	) { }

	params: RoleBasedParamModel = {
		customRole: [],
		path: '',
	};

	@Input('appUserRole')
	set appUserRole(params: RoleBasedParamModel) {
		if (params) {
			this.params.customRole = params.customRole || [];
			this.params.path = params.path || '';
		}
	}

	ngOnInit() {
		this.roleGuardService.hasCustomAccess(this.params).then(hasAccess => {
			if (hasAccess) {
				this.viewContainer.createEmbeddedView(this.templateRef);
			} else {
				this.viewContainer.clear();
			}
		});
	}
}
